import React from 'react';
import { useNavigate } from "react-router-dom";
import { Typography, Button, Box } from "@mui/material";
import { useTranslation } from 'react-i18next';

function AccountCreated() {
    const { t, i18n } = useTranslation();
    const navigate = useNavigate();

    return (
        <Box sx={{ textAlign: 'center', mt: 5, px: 2 , marginTop: '100px'}}>
            <Typography variant="h4" gutterBottom>
                {t('Administration.AccountCreatedTitle')} <br />
                {t('Administration.AccountCreatedMessage')}
            </Typography>

            <Button
                variant="contained"
                color="primary"
                sx={{ mt: 3 }}
                onClick={() => navigate(`/${i18n.language}/login`)}
            >
                {t('Administration.LoginButton')}
            </Button>
        </Box>
    );
}
export default AccountCreated;
